<template>
    <div class="partner">
        <div class="partner-content">
            <Carousel class="list" arrows autoplay :dots="false">
                <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow law"><i></i></div>
                <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow raw"><i></i></div>
                <div class="item" v-for="(item,index) in partnerList" :key="index">
                    <div class="o" v-for="(o,i) in item" :key="i">
                        <a v-link="o.link" :style="{backgroundImage :`url(${o.image})`}"></a>
                    </div>
                </div>
            </Carousel>
        </div>
    </div>
</template>
<script>
import {Carousel} from 'ant-design-vue'
import {chunk} from 'lodash'
export default {
    components:{Carousel},
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        },
        size: {
            type: Number,
            default: 18
        }
    },
    computed:{
        partnerList(){
            return chunk(this.list,this.size);
        }
    }
}
</script>
<style lang="scss" scoped>
.partner {
    height: 758px;
    width: 100%;
    .partner-content {
        @include Width;
        margin: 0 auto;
    }
    .list {
        width: 1020px;
        margin: 0 auto;
        .item {
            display: flex !important;
            flex-wrap:wrap;
            @include Width;
            .o {
                height: 160px;
                width: 170px;
                @include Flex;
                align-items: center;
                background-color: #fff;
                justify-content: center;
                border-bottom: 1px solid  #F9F9F9;
                border-right: 1px solid  #F9F9F9;
                overflow: hidden;
                a {
                    display: block;
                    @include Flex;
                    width: 100%;
                    height: 100%;
                    justify-content: center;
                    align-items: center;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                }
            }
        }
        .custom-slick-arrow {
            width: 66px;
            height: 66px;
            margin-top: -33px;
            i {
                display: inline-block;
                width: 66px;
                height: 66px;
                background: url('~@assets/images/home/partner_arrow.svg') no-repeat;
                background-size: 100%;
            }
            &.law{
                left: -68px;
                z-index: 1;
            }
            &.raw {
                right: -68px;
                i {
                    transform: rotate(180deg);
                }
            }
        }
    }
}
</style>

